<div class="esf-main-layout esf-main-layout--has-header">
  <main class="esf-main-content esf-main-content--alternative -width-max -has-transition">
    <div class="esf-container esf-container--full-width">

      <ul class="esf-progress-indicator top-margin" *ngIf="!duplicateCheckInProgress">
        <li class="esf-progress-indicator__step" [ngClass]="{'-is-complete': stepProcess > 1, '-is-current': stepProcess === 1}">
          <div class="esf-progress-indicator__item">
            <div class="esf-progress-indicator__count">
              <div class="esf-progress-indicator__count-inner">
                <div class="esf-progress-indicator__number">1</div>
              </div>
            </div>
          </div>
          <div class="esf-progress-indicator__item esf-progress-indicator__item--label">
            <span class="esf-progress-indicator__label" i18n='Text in the step process@@createCustomerComponent.stepProcess.customerData'>Customer data</span>
          </div>
          <div class="esf-progress-indicator__item esf-progress-indicator__item--separator">
            <div class="esf-progress-indicator__separator"></div>
          </div>
        </li>
        <li class="esf-progress-indicator__step" [ngClass]="{'-is-complete': stepProcess > 2, '-is-current': stepProcess === 2}">
          <div class="esf-progress-indicator__item">
            <div class="esf-progress-indicator__count">
              <div class="esf-progress-indicator__count-inner">
                <div class="esf-progress-indicator__number">2</div>
              </div>
            </div>
          </div>
          <div class="esf-progress-indicator__item esf-progress-indicator__item--label">
            <span class="esf-progress-indicator__label" i18n='Text in the step process@@createCustomerComponent.stepProcess.comuncationData'>Communication data</span>
          </div>
          <div class="esf-progress-indicator__item esf-progress-indicator__item--separator">
            <div class="esf-progress-indicator__separator"></div>
          </div>
        </li>
        <li class="esf-progress-indicator__step" [ngClass]="{'-is-current': stepProcess === 3}">
          <div class="esf-progress-indicator__item">
            <div class="esf-progress-indicator__count">
              <div class="esf-progress-indicator__count-inner">
                <div class="esf-progress-indicator__number">3</div>
              </div>
            </div>
          </div>
          <div class="esf-progress-indicator__item esf-progress-indicator__item--label">
            <span class="esf-progress-indicator__label" i18n='Text in the step process@@createCustomerComponent.stepProcess.addressData'>Address data</span>
          </div>
          <div class="esf-progress-indicator__item esf-progress-indicator__item--separator">
            <div class="esf-progress-indicator__separator"></div>
          </div>
        </li>
      </ul>

      <div class="form-wrapper" *ngIf="!duplicateCheckInProgress">
        <div class="form-content">

          <h2 class="esf-heading--section" *ngIf="stepProcess === 1" i18n='Text in the step process@@createCustomerComponent.stepProcess.customerData'>Customer data</h2>
          <h2 class="esf-heading--section" *ngIf="stepProcess === 2" i18n='Text in the step process@@createCustomerComponent.stepProcess.comuncationData'>Communication data</h2>
          <h2 class="esf-heading--section" *ngIf="stepProcess === 3" i18n='Text in the step process@@createCustomerComponent.stepProcess.addressData'>Address data</h2>

          <div class="esf-horizontal-tabs" *ngIf="stepProcess == 1">
            <ul class="esf-horizontal-tabs__list">
              <li class="esf-horizontal-tabs__list-item">
                <span class="esf-horizontal-tabs__link" style="cursor: pointer" [attr.aria-selected]="isPrivateCustomer ? true : null"
                      (click)="isPrivateCustomer = true" i18n='Text in a tab element@@createCustomerComponent.tabs.private'>Private</span>
              </li>
              <li class="esf-horizontal-tabs__list-item">
                <span class="esf-horizontal-tabs__link" style="cursor: pointer" [attr.aria-selected]="!(isPrivateCustomer) ? true : null"
                      (click)="isPrivateCustomer = false" i18n='Text in a tab element@@createCustomerComponent.tabs.company'>Company</span>
              </li>
            </ul>
            <div class="esf-horizontal-tabs__panels">

              <section class="esf-horizontal-tabs__panel" id="privateCustomer" [hidden]="!(isPrivateCustomer)">

                <span class="esf-heading" style="text-transform: uppercase" i18n='Section heading@@createCustomerComponent.sectionHeading.personal'>Personal</span>

                <form [formGroup]="customerFormPrivate" (ngSubmit)="createNewCustomer()">
                  <div class="esf-form-group">
                    <div class="esf-form-item esf-form-item--1-2 name-prefix-wrapper">
                      <div class="esf-check-radio">
                        <input class="esf-check-radio__input esf-check-radio--radio__input" formControlName="salutation"
                               type="radio" id="pmr" value="mr">
                        <label class="esf-check-radio__label esf-check-radio--radio__label" for="pmr" i18n='Form label text@@general.formLabel.Mr'>Mr.</label>
                      </div>
                      <div class="esf-check-radio">
                        <input class="esf-check-radio__input esf-check-radio--radio__input" formControlName="salutation"
                               type="radio" id="pmrs" value="mrs">
                        <label class="esf-check-radio__label esf-check-radio--radio__label" for="pmrs" i18n='Form label text@@general.formLabel.Mrs'>Mrs.</label>
                      </div>
                      <div class="esf-check-radio">
                        <input class="esf-check-radio__input esf-check-radio--radio__input" formControlName="salutation"
                               type="radio" id="notSpecified" [value]='null'>
                        <label class="esf-check-radio__label esf-check-radio--radio__label" for="notSpecified" i18n='Form label text@@general.formLabel.notSpecified'>Not specified</label>
                      </div>
                    </div>
                    <div app-form-field-text-generic
                         class="esf-form-item--1-2"
                         [optional]="true"
                         [control]="customerFormPrivate.get('title')"
                         [placeholder]="flTranslations.i18nTitle"
                         [label]="flTranslations.i18nTitle">
                    </div>
                  </div>
                  <div app-form-field-text-generic
                       [optional]="true"
                       [control]="customerFormPrivate.get('company')"
                       [placeholder]="flTranslations.i18nCompany"
                       [label]="flTranslations.i18nCompany">
                  </div>
                  <div class="esf-form-group">
                    <div app-form-field-text-generic
                         class="esf-form-item--1-2"
                         [control]="customerFormPrivate.get('firstName')"
                         [placeholder]="flTranslations.i18nFirstName"
                         [label]="flTranslations.i18nFirstName">
                    </div>
                    <div app-form-field-text-generic
                         class="esf-form-item--1-2"
                         [control]="customerFormPrivate.get('lastName')"
                         [placeholder]="flTranslations.i18nLastName"
                         [label]="flTranslations.i18nLastName">
                    </div>
                  </div>
                  <div app-form-field-datepicker
                       [optional]="true"
                       [past]="true"
                       [control]="customerFormPrivate.get('birthday')"
                       [placeholder]="flTranslations.i18nBirthday"
                       [label]="flTranslations.i18nBirthday">
                  </div>
                  <app-submit-row-buttons [useIcon]="true"
                                          [cancelButtonText]="buttonsTranslations.i18nBack"
                                          [submitButtonText]="buttonsTranslations.i18nNext"
                                          (cancelButton)="goBack()">
                  </app-submit-row-buttons>
                </form>

              </section>

              <section class="esf-horizontal-tabs__panel" id="companyCustomer" [hidden]="isPrivateCustomer">

                <form [formGroup]="customerFormCompany" (ngSubmit)="createNewCustomer()">
                  <div app-form-field-text-generic
                       [control]="customerFormCompany.get('company')"
                       [placeholder]="flTranslations.i18nCompany"
                       [label]="flTranslations.i18nCompany">
                  </div>

                  <div>
                    <span i18n='Section heading@@createCustomerComponent.sectionHeading.contactPersonOptional' class="esf-heading"
                          style="text-transform: uppercase">Contact person (optional)</span>
                  </div>

                  <div class="esf-form-group">
                    <div class="esf-form-item esf-form-item--1-2 name-prefix-wrapper">
                      <div class="esf-check-radio">
                        <input class="esf-check-radio__input esf-check-radio--radio__input" formControlName="salutation"
                               type="radio" id="cmr" value="mr" (click)="removeRadioValue('mr', customerFormCompany)">
                        <label class="esf-check-radio__label esf-check-radio--radio__label" for="cmr" i18n='Form label text@@general.formLabel.Mr'>Mr.</label>
                      </div>
                      <div class="esf-check-radio">
                        <input class="esf-check-radio__input esf-check-radio--radio__input" formControlName="salutation"
                               type="radio" id="cmrs" value="mrs" (click)="removeRadioValue('mrs',customerFormCompany)">
                        <label class="esf-check-radio__label esf-check-radio--radio__label" for="cmrs" i18n='Form label text@@general.formLabel.Mrs'>Mrs.</label>
                      </div>
                      <div class="esf-check-radio">
                        <input class="esf-check-radio__input esf-check-radio--radio__input" formControlName="salutation"
                               type="radio" id="notSpecifiedCompany" [value]='null'>
                        <label class="esf-check-radio__label esf-check-radio--radio__label" for="notSpecifiedCompany" i18n='Form label text@@general.formLabel.notSpecified'>Not specified</label>
                      </div>
                    </div>
                    <div app-form-field-text-generic
                         class="esf-form-item--1-2"
                         [control]="customerFormCompany.get('title')"
                         [placeholder]="flTranslations.i18nTitle"
                         [label]="flTranslations.i18nTitle">
                    </div>
                  </div>
                  <div class="esf-form-group">
                    <div app-form-field-text-generic
                         class="esf-form-item--1-2"
                         [control]="customerFormCompany.get('firstName')"
                         [placeholder]="flTranslations.i18nFirstName"
                         [label]="flTranslations.i18nFirstName">
                    </div>
                    <div app-form-field-text-generic
                         class="esf-form-item--1-2"
                         [control]="customerFormCompany.get('lastName')"
                         [placeholder]="flTranslations.i18nLastName"
                         [label]="flTranslations.i18nLastName">
                    </div>
                  </div>
                  <div app-form-field-datepicker
                       [past]="true"
                       [control]="customerFormCompany.get('birthday')"
                       [placeholder]="flTranslations.i18nBirthday"
                       [label]="flTranslations.i18nBirthday">
                  </div>
                  <app-submit-row-buttons [useIcon]="true"
                                          [cancelButtonText]="buttonsTranslations.i18nBack"
                                          [submitButtonText]="buttonsTranslations.i18nNext"
                                          (cancelButton)="goBack()">
                  </app-submit-row-buttons>
                </form>

              </section>

            </div>
          </div>

          <div *ngIf="stepProcess == 2" class="esf-horizontal-tabs__panel">
            <form [formGroup]="communicationForm" (ngSubmit)="createNewCommunication()">
              <div app-form-field-email-checker
                   [optional]="true"
                   [selectedClub]="selectedClub"
                   [control]="communicationForm.controls['email']"
                   (searchResultsEmpty)="isEmailValid = $event">
              </div>
              <div app-form-field-toggle
                   *ngIf="!selectedClub.tixxExternalSso"
                   [control]="communicationForm.controls['createWithAuthorization']"
                   [innerLabel]="flTranslations.i18nSetEmailAuthorization">
              </div>
              <div app-form-field-text-generic
                   [optional]="true"
                   [control]="communicationForm.get('phone')"
                   [placeholder]="flTranslations.i18nTelephone"
                   [label]="flTranslations.i18nTelephone">
              </div>
              <div app-form-field-text-generic
                   [optional]="true"
                   [control]="communicationForm.get('mobile')"
                   [placeholder]="flTranslations.i18nMobile"
                   [label]="flTranslations.i18nMobile">
              </div>
              <app-submit-row-buttons [useIcon]="true"
                                      [isFieldValid]="isEmailValid && authorisationValidity"
                                      [cancelButtonText]="buttonsTranslations.i18nBack"
                                      [submitButtonText]="buttonsTranslations.i18nNext"
                                      (cancelButton)="goBackAStep()">
              </app-submit-row-buttons>
            </form>
          </div>

          <div *ngIf="stepProcess == 3" class="esf-horizontal-tabs__panel">
            <form [formGroup]="addressesForm" (ngSubmit)="createNewAddress()" [hidden]="!(stepProcess === 3)">
              <div class="esf-form-item esf-form-validation">
                <label i18n='Form label text@@general.formLabel.street' class="esf-form-item__label" for="street">Street</label>
                <input type="text" class="esf-form-item__field" id="street" i18n-placeholder="Form placeholder text@@general.formPlaceholder.street"
                       placeholder="Enter street" formControlName="street" autocomplete="off"
                       [appGooglePlaces]="addressesForm.value?.street"
                       (onAddressSelect)="fillAddressValues($event)">
              </div>
              <div class="esf-form-group">
                <div class="esf-form-item esf-form-item--1-2 esf-form-validation">
                  <label i18n='Form label text@@general.formLabel.postCode' class="esf-form-item__label" for="postCode">Post code</label>
                  <input type="text" class="esf-form-item__field" id="postCode" i18n-placeholder="Form placeholder text@@general.formPlaceholder.postCode"
                         placeholder="Enter post code" formControlName="postalCode" autocomplete="off">
                </div>
                <div class="esf-form-item esf-form-item--1-2 esf-form-validation">
                  <label i18n='Form label text@@general.formLabel.city' class="esf-form-item__label" for="city">City</label>
                  <input type="text" class="esf-form-item__field" id="city" i18n-placeholder="Form placeholder text@@general.formPlaceholder.city"
                         placeholder="Enter city" formControlName="city" autocomplete="off">
                </div>
              </div>

              <div class="esf-form-item esf-form-validation">
                <label i18n='Form label text@@general.formLabel.country' class="esf-form-item__label" for="country">Country</label>
                <div class="esf-select">
                  <select class="esf-form-item__field esf-select__field" id="country" i18n-placeholder="Form placeholder text@@general.formPlaceholder.country"
                          formControlName="country" autocomplete="off">
                    <option [value]="undefined"></option>
                    <option *ngFor="let country of countries" [value]="country.iso2">{{ country.name }}</option>
                  </select>
                </div>
              </div>

              <app-submit-row-buttons [useIcon]="true"
                                      [cancelButtonText]="buttonsTranslations.i18nBack"
                                      [submitButtonText]="buttonsTranslations.i18nCreateCustomer"
                                      [spinnerName]="spinnerName"
                                      (cancelButton)="goBackAStep()">
              </app-submit-row-buttons>
            </form>
          </div>
        </div>
      </div>

      <app-duplicate-check
                           [customer]="fullCustomerForm.value"
                           [address]="addressesForm.value"
                           [listOfDuplicates]="listOfDuplicates"
                           (openModal)="openModal()"
                           *ngIf="duplicateCheckInProgress">
      </app-duplicate-check>

      <form class="padding-top" (ngSubmit)="createCustomer()" *ngIf="duplicateCheckInProgress">

        <app-submit-row-buttons [useIcon]="true"
                                [cancelButtonText]="buttonsTranslations.i18nBack"
                                [submitButtonText]="buttonsTranslations.i18nIgnoreAndCreateNew"
                                [spinnerName]="spinnerName"
                                (cancelButton)="duplicateCheckInProgress = !duplicateCheckInProgress">
        </app-submit-row-buttons>
      </form>

    </div>
  </main>

  <app-local-modal [title]="this.existingCustomer"
                   [submitButton]="this.useExisting"
                   (submitClicked)="navigateToCustomer()">
    <p i18n="Modal paragraph text@@createCustomerComponent.modalParagraph.workWithExistingInstead">Do you want to work with this existing customer instead?</p>
  </app-local-modal>

  <app-leave-confirmation></app-leave-confirmation>
</div>
